module.exports = __webpack_public_path__ + "img/Journaliste_06_TPA.7182c154.jpg";